import { render, staticRenderFns } from "./CropClassifications.vue?vue&type=template&id=cb82a3a2&"
import script from "./CropClassifications.vue?vue&type=script&lang=js&"
export * from "./CropClassifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports